"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsService = exports.EventCategory = void 0;
var core_api_1 = require("@ikegps/core-api");
var mobx_1 = require("mobx");
var index_1 = require("./index");
var EventCategory;
(function (EventCategory) {
    EventCategory["Auth"] = "Authentication";
    EventCategory["BigMap"] = "BigMap";
    EventCategory["Collection"] = "Collection";
    EventCategory["Export"] = "Export";
    EventCategory["Form"] = "Form";
    EventCategory["Import"] = "Import";
    EventCategory["Mutate"] = "Mutate";
    EventCategory["Performance"] = "Performance";
    EventCategory["Route"] = "Route";
    EventCategory["Upload"] = "Upload";
    EventCategory["FormImportUpload"] = "FormImportUpload";
})(EventCategory || (exports.EventCategory = EventCategory = {}));
var AnalyticsService = /** @class */ (function () {
    function AnalyticsService() {
        this.__priority = 100;
        this.EventCategory = EventCategory;
        this.DEBOUNCE_TIME = 1000;
        this.TimingEventType = core_api_1.TimingEventType;
        this.TimingEventAction = core_api_1.TimingEventAction;
    }
    AnalyticsService.prototype.init = function () {
        var _this = this;
        (0, mobx_1.reaction)(function (_) { return index_1.Services.User.current; }, function (_) { return _this.setUser(); }, { fireImmediately: true });
        (0, mobx_1.reaction)(function (_) { return index_1.Services.Department.current; }, function (_) { return _this.setDepartment(); }, { fireImmediately: true });
        // Track that the system started
        this.trackEvent(EventCategory.Auth, 'page:init', 'init', 1);
    };
    AnalyticsService.prototype.setUser = function () {
        if (index_1.Services.Window.window.ga == null) {
            return;
        }
        var user = index_1.Services.User.current;
        if (user == null) {
            index_1.Services.Window.window.ga('set', 'userId', null);
        }
        else {
            index_1.Services.Window.window.ga('set', 'userId', user.objectId);
        }
    };
    AnalyticsService.prototype.setDepartment = function () {
        if (index_1.Services.Window.window.ga == null) {
            return;
        }
        var department = index_1.Services.Department.current;
        if (department == null) {
            index_1.Services.Window.window.ga('set', 'dimension1', null);
        }
        else {
            index_1.Services.Window.window.ga('set', 'dimension1', department.objectId);
        }
    };
    AnalyticsService.prototype.trackTiming = function (type, action, collectionId, recordedAt) {
        if (index_1.Services.User.hasUser) {
            var data = {
                events: [{
                        type: type,
                        action: action,
                        collectionId: collectionId,
                        recordedAt: recordedAt.toISOString()
                    }]
            };
            index_1.Services.Department.rest.Event.create(data);
        }
    };
    /**
     * Track event.
     *
     * @param category Typically the object that was interacted with (e.g. 'Collection')
     * @param action The type of interaction (e.g. 'brightness:increase')
     * @param label Useful for categorizing events (e.g. Id of object affected)
     * @param value A numeric value associated with the event (e.g. 42)
     */
    AnalyticsService.prototype.trackEvent = function (category, action, label, value) {
        if (index_1.Services.Window.window.ga == null) {
            return;
        }
        index_1.Services.Window.window.ga('send', 'event', category, action, label, value);
    };
    return AnalyticsService;
}());
exports.AnalyticsService = AnalyticsService;
//# sourceMappingURL=analytics.service.js.map